<template>
    <div class="evaluate">
        <!-- 商品列表 -->
        <div class="sale-box" v-for="(item,index) in order_product" :key="index">
            <div class="flex sale__item">
                <img :src="item.product_cover_img" alt="">
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{item.product_name}}</span>
                    <span class="fs_22 c_98" v-if="item.product_sku_name">规格: {{item.product_sku_name}}</span>
                    <span v-else></span>
                </div>
            </div>
            <div class="flex__between__center star-box"> 
                <span class="fs_28 c_4d">描述相符</span>
                <span>&nbsp;</span>
                <span @click='star(index,index1)' v-for="(item1,index1) in item.star_array" :key="index1" class="jcicon jcicon-like_fill fs_40" :class="item1.is_chose?'c_main':'c_e6'"></span>
                <span>&nbsp;</span>
                <span v-if="item.star>3">好评</span>
                <span v-else-if="item.star==3">中评</span>
                <span v-else>差评</span>
            </div>
            <div class="text-box">
                <textarea name="" id="" v-model="item.content" placeholder="亲，咱平台的服务能够达到您的预期吗？您的评价是商家不 断进步的源泉，写点什么吧"></textarea>
            </div>
            <images-upload :product_index="index" :imageList="item.img_path" @upload='imageUpload' @delete='imageDelete'></images-upload>
        </div>
        <div class="footer">
            <button @click="evaluate">评价</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "Evaluate",
    data(){
        return{
            order_product:[],
            evaluates:{
                user_id: localStorage.user_id,
                source: 1,
                order_id: '',
                review_product:''
            }
        }
    },
    methods:{
        imageUpload (res) {
            this.order_product[res.product_index].img_path = this.order_product[res.product_index].img_path.concat(res.uploadImageList);
        },
        imageDelete (res) {
            this.order_product[res.product_index].img_path.splice(res.index, 1)
        },
        // 评星
        star(index,index1){
            for (let i = 0; i < 5; i++) {
                this.order_product[index].star_array[i].is_chose = false;
            }
            for (let i=0;i<index1+1;i++) {
                this.order_product[index].star_array[i].is_chose= true;
            }
            this.order_product[index].star=index1+1;
        },
        // 评价
        evaluate(){
            let order_arr=[];
            for(let i=0;i<this.order_product.length;i++){
                let order_obj={};
                order_obj.product_id=this.order_product[i].product_id;
                order_obj.content=this.order_product[i].content;
                order_obj.product_name=this.order_product[i].product_name;
                order_obj.star=this.order_product[i].star;
                order_obj.sku=this.order_product[i].product_sku_name;
                order_obj.img_path=this.order_product[i].img_path;
                order_arr.push(order_obj);
            }
            this.evaluates.review_product=JSON.stringify(order_arr);
            this.axios.post('/wechat.php/Mall/submitReview',this.evaluates).then(
                res=>{
                    if(res.data.code==1){
                        this.order_product=res.data.data.order_product;
                        this.$dialog.alert({
                            message: res.data.message
                        }).then(() => {
                            this.$router.go(-1);
                        });
                    }
                }
            )
        }
    },
    mounted(){
        this.evaluates.order_id=this.$route.params.id;
        this.axios.post('/wechat.php/Mall/getReviewData',{
            user_id: localStorage.user_id,
            order_id: this.$route.params.id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.order_product=res.data.data.order_product;
                }
            }
        )
    }
}
</script>
<style scoped>
.sale-box{
    padding: 0 0 30px;
    margin-top: 15px;
    background: #fff;
    overflow: hidden;
}
.sale-box:first-child{
    margin-top: 0;
}
.sale__item{
    margin-top: 30px;
    padding: 0 30px;
}
.sale__item:last-child{
    border: 0;
}
.sale__item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    /* width: 480px; */
    margin-left: 30px;
}
.star-box{
    height: 100px;
    padding: 0 30px;
    border-bottom: 2px solid #e6e6e6;
}
.text-box{
    padding: 30px;
}
.text-box textarea{
    width: 100%;
    height: 150px;
    line-height: 38px;
    font-size: 26px;
    resize: none;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
}
.footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/mall/Evaluate.vue